import styled from "styled-components";

export const Product = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto;
    background: #fff;
    border-radius: 16px;
    padding: 16px;
    gap: 16px;
    align-items: center;

    @media screen and (max-width: 1100px) {
        grid-template-columns: 1fr;
    }

.product-details {
    display: grid;
    grid-template-columns: 200px 1fr;
    gap: 32px;
    align-items: center;

    @media screen and (max-width: 1100px) {
        grid-template-columns: 1fr;
        gap: 8px;
    }

    h4 {
        font-size: 18px;
        font-weight: 500;
        line-height: 28px;

    @media screen and (max-width: 1100px) {
        text-align: center;
    }
    }
}


.btn-container {
    display: flex;
    gap: 8px;
    align-items: center;
    width: max-content;

.view-btn {
    color: #3f1bd0 !important;
}

.add-btn {
    display: flex;
    gap: 5px;
    align-items: center;
}

@media screen and (max-width: 1100px) {
        width: 100%;
        justify-content: center;
    }
}
`